import {
  makeStyles,
  tokens,
  Text,
  Popover,
  PopoverTrigger,
  PopoverSurface,
} from "@fluentui/react-components";
import { InfoRegular } from "@fluentui/react-icons";
import React from "react";

type FormSectionProps = {
  sectionText: string;
  content: React.ReactNode;
  popoverText?: React.ReactNode;
};
const useStyles = makeStyles({
  section: {
    marginTop: "40px",
    width: " 100%",
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
  formSectionText: {
    fontWeight: tokens.fontWeightBold,
    fontSize: tokens.fontSizeBase600,
  },
  info: {
    width: "28px",
    height: "28px",
    cursor: "pointer",
  },
});
export const FormSection = ({
  sectionText,
  content,
  popoverText,
}: FormSectionProps) => {
  const styles = useStyles();
  return (
    <div className={styles.section}>
      <div className={styles.sectionHeader}>
        <Text as="b" className={styles.formSectionText}>
          {sectionText}
        </Text>
        {popoverText && (
          <Popover>
            <PopoverTrigger disableButtonEnhancement>
              <InfoRegular className={styles.info} />
            </PopoverTrigger>

            <PopoverSurface>
              <p>{popoverText}</p>
            </PopoverSurface>
          </Popover>
        )}
      </div>
      {content}
    </div>
  );
};
